<template>
  <Modal :showModal="isModalOpen" @close="closeModal">
    <!-- Slot de nombre body -->
    <template #header>
      <h5>{{ modalTitle }}</h5>
    </template>
    <template #body>
      <img class="modal__img" :src="modalContent" />
    </template>
  </Modal>

  <h2>Radar MIRA 35-C</h2>

  <div class="cards">
    <div v-for="registro in registros" :key="registro.name" class="card">
      <div class="card__title">
        {{ registro.name }}
      </div>
      <div class="card__content">
        <div class="card__img">
          <img
            v-on:click="openModal(registro.url, registro.name)"
            :src="registro.url + '?v=' + currentDate"
            :title="registro.name"
            :alt="registro.name"
            :onerror="
              `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
            "
            :broken="
              `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
            "
          />
        </div>
        <p>
          {{ registro.description }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Modal from "@/components/common/Modal.vue";
export default {
  components: {
    Modal,
  },
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    const basePath_images = process.env.VUE_APP_TEST_IMAGE;
    const currentDate = new Date().getTime();
    return {
      basePath,
      basePath_images,
      currentDate,
    };
  },
  data() {
    return {
      modalTitle: "",
      modalContent: "",
      isModalOpen: false,
      image: null,

      registros: [
        {
          name: "Reflectividad Equivalente (dBZ)	",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/ultimo.z1.png",
          description:
            "El factor de reflectividad equivalente (Ze): específica los tipos de hidrometeóros en un volumen de resolución, los colores intensos de rango positivo indican gotas de lluvia más grandes, mientras que los otros se trata de partículas de nube.",
        },
        {
          name: "Velocidad Doppler (m/s)	",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/ultimo.v1.png",
          description:
            "Velocidad Doppler (VElg): indica con qué velocidad vertical se esta moviendo los hidrometeoros a medida que varía la altura, se observa que los hidrometeoros ascienden (valores postivos) y descendien (valores negativos).",
        },
        {
          name: "Relación de decorrelación lineal",
          url:
            "https://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/images/LAMAR/monitoreo/ultimo.ldr.png",
          description:
            "Relación de decorrelación lineal (LDR): el radar recibe el promedio espectro de potencia en dos canales (horizontal y vertical) polarizada linealmente, los cuales permiten clasificar tipos de objetivos que se encuentran en la baja atmósfera, como son los hidrometeoros, insectos,etc.",
        },
      ],
    };
  },
  methods: {
    openModal(img, title) {
      this.modalTitle = title;
      this.modalContent = img;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.image-background {
  display: flex;
  justify-content: center;
}
img {
  cursor: pointer;
}
.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1em;
}

@media (max-width: 768px) {
  .cards {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

.card {
  border: 1px solid #ccc;
  border-radius: 5px;
}

.card__title {
  background-color: #0099ff;
  color: white;
  padding: 0.5em;
  text-align: center;
}

.card__btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0099ff;
  color: white;
  border-radius: 100%;
  opacity: 0.5;
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.card__img {
  overflow: hidden;
}
.card__img > img:hover {
  scale: 105%;
  transition-duration: 200ms;
  transition-property: scale;
  transition-timing-function: ease-in-out;
}

.card__content > p {
  padding: 0.5em;
}

.modal__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
</style>
